const pluralsRules = new Intl.PluralRules('en-US', { type: 'ordinal' })

const pluralMapping: Record<Intl.LDMLPluralRule, string> = {
	zero: 'th',
	one: 'st',
	two: 'nd',
	few: 'rd',
	other: 'th',
	many: 'th',
}

export const getOrdinalNumber = (value: number) => {
	if (typeof value !== 'number' || Number.isNaN(value)) {
		return ''
	}

	const plural = pluralsRules.select(value)

	if (!plural) {
		return value.toString()
	}

	const suffix = pluralMapping[plural]

	if (!suffix) {
		return value.toString()
	}

	return `${value}${suffix}`
}
